import { FILE_TYPE } from "src/app/@core/models/enums";

/* eslint-disable */
export function objectToDictionary<T>(
    array: T[],
    indexKey: keyof T | (keyof T)[] | string | string[] | ((arg0: T) => string),
    formatKey?: Function
): { [key: string]: T } {
    const normalizedObject: { [key: string]: T } = {};

    /**
     * If the key is a string, convert it to an array
     * @param  {String|Array} path The path
     * @return {Array}             The path array
     */
    const stringToPath = function (path: string | string[]): string[] {
        if (typeof path !== 'string') return path;

        const output: string[] = [];
        path.split('.').forEach(function (item) {
            item.split(/\[([^}]+)\]/g).forEach(function (key) {
                if (key.length > 0) {
                    output.push(key);
                }
            });
        });

        return output;
    };

    if (typeof indexKey === 'function') {
        const extractIndexFunction = indexKey as (arg0: T) => string;
        for (let i = 0; i < array.length; i++) {
            const key = extractIndexFunction(array[i]);
            normalizedObject[key] = array[i];
        }
    } else {
        const indexKeyArray = stringToPath(indexKey as string | string[]);
        for (let i = 0; i < array.length; i++) {
            let currentKey: any = array[i];
            for (let j = 0; j < indexKeyArray.length; j++) {
                if (currentKey[indexKeyArray[j]] === undefined) {
                    currentKey = undefined;
                    break;
                }
                currentKey = currentKey[indexKeyArray[j]];
            }

            if (currentKey !== undefined && currentKey !== null) {
                let key = currentKey.toString()
                if (formatKey) {
                    key = formatKey(key)
                }
                normalizedObject[key] = array[i];
            }
        }
    }

    return normalizedObject;
}

export function objectToDictionaryArray<T>(
    array: T[],
    indexKey: keyof T | (keyof T)[] | string | string[] | ((arg0: T) => string)
): { [key: string]: T[] } {
    const normalizedObject: { [key: string]: T[] } = {};

    const stringToPath = function (path: string | string[]): string[] {
        if (typeof path !== 'string') return path;

        const output: string[] = [];
        path.split('.').forEach(function (item) {
            item.split(/\[([^}]+)\]/g).forEach(function (key) {
                if (key.length > 0) {
                    output.push(key);
                }
            });
        });

        return output;
    };

    if (typeof indexKey === 'function') {
        const extractIndexFunction = indexKey as (arg0: T) => string;
        for (let i = 0; i < array.length; i++) {
            const key = extractIndexFunction(array[i]);
            if (!normalizedObject[key]) {
                normalizedObject[key] = [];
            }
            normalizedObject[key].push(array[i]);
        }
    } else {
        const indexKeyArray = stringToPath(indexKey as string | string[]);
        for (let i = 0; i < array.length; i++) {
            let currentKey: any = array[i];
            for (let j = 0; j < indexKeyArray.length; j++) {
                if (currentKey[indexKeyArray[j]] === undefined) {
                    currentKey = undefined;
                    break;
                }
                currentKey = currentKey[indexKeyArray[j]];
            }

            if (currentKey !== undefined && currentKey !== null) {
                const key = currentKey.toString();
                if (!normalizedObject[key]) {
                    normalizedObject[key] = [];
                }
                normalizedObject[key].push(array[i]);
            }
        }
    }

    return normalizedObject;
}

/* eslint-disable */
export function objectToDictionaryWithMultipleKeys<T extends Record<string, any>>(array: T[], indexKey: string[] | string, delimiter?: string, keyOfValueToBeReturned?: string, formatKey?: Function): { [key: string]: T } {
    const normalizedObject: { [key: string]: T } = {};
    // Converting string to array
    if (!Array.isArray(indexKey)) {
        indexKey = [indexKey]
    }
    // Default Value of delimiter
    if (!delimiter?.length) {
        delimiter = '#'
    }
    //Itrating through Object Array; 
    for (let i = 0; i < array.length; i++) {
        let key = ''
        let currentElement: T | null = array[i];
        // Creating Key for the Objects
        for (let j = 0; j < indexKey.length; j++) {
            if (array[i][indexKey[j]] == null || array[i][indexKey[j]] == undefined) {

                currentElement = null;
                break;
            }

            key = key + delimiter + array[i][indexKey[j]];
            if (formatKey) {
                key = formatKey(key)
            }
        }
        key = key.slice(1);
        if (currentElement) {
            //keyOfValueToBeReturned is the key whose value should be returned, if it is undefined then entire object will be returned 
            normalizedObject[key] = keyOfValueToBeReturned ? currentElement[keyOfValueToBeReturned] : currentElement;
        }
    }
    return normalizedObject;
}

export function getFileType(filenameWithExtension: string): FILE_TYPE | undefined {
    if (!filenameWithExtension) {
        return undefined;
    }
    const extension = (filenameWithExtension || '').split('.').pop()?.toLowerCase();
    switch (extension) {
        case 'pdf':
            return FILE_TYPE.PDF;
        case 'doc':
        case 'docx':
            return FILE_TYPE.WORD;
        case 'txt':
            return FILE_TYPE.TEXT;
        case 'html':
        case 'htm':
            return FILE_TYPE.HTML;
        case 'py':
            return FILE_TYPE.PYTHON;
        case 'md':
            return FILE_TYPE.MARKDOWN;
        case 'ppt':
        case 'pptx':
            return FILE_TYPE.POWERPOINT;
        case 'xls':
        case 'xlsx':
            return FILE_TYPE.EXCEL;
        case 'json':
            return FILE_TYPE.JSON;
        case 'jpg':
            return FILE_TYPE.JPG;
        case 'png':
            return FILE_TYPE.PNG;
        case 'jpeg':
            return FILE_TYPE.JPEG;
        default:
            return undefined;
    }
}
